import { lazy, type ComponentProps, type ReactElement } from 'react';
import { Route } from 'react-router-dom';

export const PortalApp = lazy(() =>
  import('./pages/PortalApp').then((module) => ({ default: module.PortalApp }))
);

type CustomerPortalRouteElement = ReactElement<ComponentProps<typeof Route>>;

export const CUSTOMER_PORTAL_ROUTE_ELEMENTS: readonly CustomerPortalRouteElement[] = [
  <Route key="/portal/*" path="/portal/*" element={<PortalApp />} />,
  <Route key="/login/redeem" path="/login/redeem" element={<PortalApp />} />,
];
